import { Box } from "@mui/material";
import HeroSection from "./HeroSection";
import NewsSection from "./NewsSection";
import PublicationsSection from "./PublicationsSection";
import BooksSection from "./BooksSection";
import ProjectsSection from "./ProjectsSection";
import DashboardSection from "./DashboardSection";

const HomepageContainer = () => {
  return (
    <>
      <Box
        style={{
          maxWidth: "100vw",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <HeroSection />
        <NewsSection />
        <PublicationsSection />
        <BooksSection />
        <ProjectsSection />
        <DashboardSection />
      </Box>
    </>
  );
};

export default HomepageContainer;
